import React from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TablePagination,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

type Profile = {
  name: string;
  informinterval: number;
  dayskeepstats: number;
  savestats: boolean;
  saveLog: boolean;
  saveParamValues: boolean;
  saveParamValuesInterval: number;
  saveParamValuesOnChange: boolean;
  saveParamValuesOnBoot: boolean;
  scriptname: string;
  baseprofile: string;
  inheritFromParent: boolean;
};

interface Props {
  columns: { key: string; label: string }[];
  rows: Profile[];
  page: number;
  rowsPerPage: number;
  count: number;
  onEdit: (r: Profile) => void;
  onDelete: (name: string) => void;
  onChangePage: (_: unknown, page: number) => void;
  onChangeRowsPerPage: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function ProfileTable({ columns, rows, page, rowsPerPage, count, onEdit, onDelete, onChangePage, onChangeRowsPerPage }: Props) {
  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      <TableContainer sx={{ maxHeight: '58vh', backgroundColor: '#fff' }}>
        <Table size="medium">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5',}}>
              {columns.map((c) => (
                <TableCell key={c.key} sx={{ color: '#222', fontWeight: 600,  fontSize: 14, minWidth: 140, padding: '16px 20px', borderBottom: '1px solid #ddd', whiteSpace: 'normal',}}> {c.label}</TableCell>
              ))}
              <TableCell sx={{ color: '#222', fontWeight: 600, fontSize: 14, minWidth: 140, padding: '16px 20px', borderBottom: '1px solid #ddd', whiteSpace: 'nowrap', }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.name} hover sx={{height: 64,'& td': {borderBottom: 'none'}, '&:hover': {backgroundColor: '#f8f8f8'} }}>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.name}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.informinterval}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.dayskeepstats}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.savestats ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.saveLog ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.saveParamValues ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14}}>{r.saveParamValuesInterval}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.saveParamValuesOnChange ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.saveParamValuesOnBoot ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14}}>{r.scriptname}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.baseprofile}</TableCell>
                   <TableCell sx={{ color: '#222', fontSize: 14 }}>{r.inheritFromParent ? 'Yes' : 'No'}</TableCell>
                   <TableCell sx={{ whiteSpace: 'nowrap' }}>
                   <IconButton size="small" onClick={() => onEdit(r)} sx={{color: '#555', '&:hover': {backgroundColor: '#eeeeee'}}}><EditIcon fontSize="small" /></IconButton>
                   <IconButton size="small" onClick={() => onDelete(r.name)} sx={{color: '#555','&:hover': {backgroundColor: '#eeeeee'}}}><DeleteIcon fontSize="small" /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 20]}
        sx={{ backgroundColor: '#fff', color: '#333','& .MuiTablePagination-selectLabel': {color: '#333'},'& .MuiTablePagination-displayedRows': {color: '#333'},'& .MuiSelect-select': {color: '#333'}, '& .MuiIconButton-root': {color: '#555'}}}
      />
    </Box>
  );
}


